<template>
  <v-navigation-drawer :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" temporary right width="380">
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("candidates.filtersTitle") }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('update:modelValue', false)"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-container>
      <v-autocomplete
        v-model="filters.profession"
        :items="optionsProfession"
        :label="$t('candidates.filters.profession')"
        multiple
        chips
        clearable
        hide-details
        class="mb-4"
      />
      <v-autocomplete
        v-model="filters.specialization"
        :items="optionsSpecialization"
        :label="$t('candidates.filters.specialization')"
        multiple
        chips
        clearable
        hide-details
        class="mb-4"
      />
      <v-autocomplete
        v-model="filters.lookingPosition"
        :items="optionsLookingPosition"
        :label="$t('candidates.filters.lookingPosition')"
        multiple
        chips
        clearable
        hide-details
        class="mb-4"
      />
      <v-autocomplete
        v-model="filters.cvSource"
        :items="optionsCVSource"
        :label="$t('candidates.filters.cvSource')"
        multiple
        chips
        clearable
        hide-details
        class="mb-4"
      />
      <v-select
        v-model="filters.contacted"
        :items="triStateOptions"
        item-title="title"
        item-value="value"
        :label="$t('candidates.filters.contacted')"
        hide-details
        outlined
        class="mb-4"
      />
      <v-select
        v-model="filters.hasCV"
        :items="triStateOptions"
        item-title="title"
        item-value="value"
        :label="$t('candidates.filters.hasCv')"
        hide-details
        outlined
        class="mb-4"
      />
      <v-divider class="my-2"></v-divider>
      <v-btn color="primary" class="mr-2" @click="$emit('apply')">{{ $t("candidates.filters.apply") }}</v-btn>
      <v-btn variant="text" @click="$emit('reset')">{{ $t("candidates.filters.reset") }}</v-btn>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import { defineComponent } from "vue";

// Presentational filters drawer extracted from Candidati.vue.
// `filters` is the shared reactive object owned by the parent; binding the
// selects directly keeps the parent's deep watcher + URL/localStorage
// persistence behaviour identical to the pre-split component.
export default defineComponent({
  name: "CandidateFiltersDrawer",
  props: {
    modelValue: { type: Boolean, default: false },
    filters: { type: Object, required: true },
    optionsProfession: { type: Array, default: () => [] },
    optionsSpecialization: { type: Array, default: () => [] },
    optionsLookingPosition: { type: Array, default: () => [] },
    optionsCVSource: { type: Array, default: () => [] },
  },
  emits: ["update:modelValue", "apply", "reset"],
  computed: {
    triStateOptions() {
      return [
        { title: this.$t("candidates.triState.all"), value: null },
        { title: this.$t("candidates.triState.yes"), value: true },
        { title: this.$t("candidates.triState.no"), value: false },
      ];
    },
  },
});
</script>
